define(function(require) {
    'use strict';
    var defineComponent = require('flightjs').component;
    return defineComponent(ChatFlight);
    function ChatFlight() {
        this.defaultAttrs({
            expandChatBoxSelector: '[data-chat-expand]'
        });

        this.expand = function(event) {
            event.preventDefault();
            window.$zopim.livechat.window.show();
        };

        this.show = function(event) {
            event.preventDefault();

            if (window.$zopim.livechat.isChatting()) {
                window.$zopim.livechat.window.show();
            } else {
                window.$zopim.livechat.button.show();
            }
        };

        this.hide = function(event) {
            event.preventDefault();
            window.$zopim.livechat.hideAll();
        };

        this.onZopimLoaded = function() {
            var self = this;

            this.on('click', {
                expandChatBoxSelector: this.expand
            });

            this.on('chatSupportOnline', this.show);
            this.on('chatSupportOffline', this.hide);

            // Zopim don't have the API to allow us to get the assigned department id.
            // __99departmentId is a hack we added in GTM to work around the issue
            var departmentId = $zopim.livechat.__99departmentId;

            if (departmentId) {
                this.setStatusByDepartment(departmentId);
            }

            window.$zopim.livechat.setOnStatus(function(status) {
                // We need to hide the widget when the assigned department is offline
                // Zendesk chat doesn't have that feature at the moment.
                // Issue: https://support.zendesk.com/hc/en-us/requests/1994340
                // Hence the existence of this hack
                if (status === 'online' && self.isDepartmentOnline(departmentId)) {
                    self.trigger('chatSupportOnline');
                } else {
                    self.trigger('chatSupportOffline');
                }
            });
        };

        this.setStatusByDepartment = function(departmentId) {
            var self = this;

            window.$zopim.livechat.setOnConnected(function() {
                var status;

                if (self.isDepartmentOnline(departmentId)) {
                    status = 'online';
                } else {
                    status = 'offline';
                }
                window.$zopim.livechat.setStatus(status);
            });
        }

        this.isDepartmentOnline = function(departmentId) {
            var department = window.$zopim.livechat.departments.getDepartment(departmentId);

            if (department) {
                return department.status === 'online';
            }

            return false;
        };

        this.after('initialize', function() {
            var timeoutInMs = 10000;
            var self = this;
            var zopimChecker;

            zopimChecker = window.setInterval(function() {
                if (window.$zopim) {
                    window.$zopim(function() {
                        self.onZopimLoaded();
                    });

                    window.clearInterval(zopimChecker);
                }
            }, 100);

            window.setTimeout(function() {
                if (zopimChecker) {
                    window.clearInterval(zopimChecker);
                }
            }, timeoutInMs);
        });
    }
});



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/chat.js
 **/